(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-claim/assets/init.js') >= 0) return;  svs.modules.push('/modules/tickets-claim/assets/init.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const VoucherInput = svs.ticketsRedeem.VoucherInput;
const BubbleBackground = svs.ticketsClaim.BubbleBackground;
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const Icon = svs.ui.ReactIcon;
const {
  branding
} = svs.core.template.data.templateConfig;
const {
  useState,
  useEffect
} = React;
const VoucherRedeem = () => {
  useEffect(() => {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      redeemCode.value && handleRedeem();
    }
  }, []);
  const redeemCodeError = function (code) {
    let invalidOrRedeemedCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let error = '';
    if (!code) {
      error = 'Du måste ange en kod.';
    } else if (code.split(' ').join('').length !== 12 || invalidOrRedeemedCode) {
      error = React.createElement("span", null, "Hoppsan! Koden \xE4r felaktigt inmatad eller f\xF6rbrukad. Kontrollera koden och f\xF6rs\xF6k igen. Har du precis f\xF6rs\xF6kt l\xF6sa in din presentlott, kontrollera om lotten finns i", ' ', React.createElement("a", {
        href: svs.core.urlMapping.get('myBetsHome')
      }, "Mina spel"), ". Om koden \xE4r \xE4ldre \xE4n ett \xE5r \xE4r den utg\xE5ngen och g\xE5r inte l\xE4ngre att l\xF6sa in.");
    }
    return error;
  };
  const handleInputBlur = e => {
    e && e.preventDefault();
    const codeError = redeemCodeError(redeemCode.value);
    codeError && setRedeemCode(_objectSpread(_objectSpread({}, redeemCode), {}, {
      error: codeError
    }));
  };
  const handleInputChange = val => {
    if (val.length === 16) {
      val = val.substring(0, val.length - 1);
    }
    setRedeemCode({
      error: '',
      value: val
    });
  };
  const handleKeyUp = e => {
    if (e.key === 'Enter') {
      handleRedeem();
    }
  };
  const handleRedeem = async function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    e && e.preventDefault();
    if (redeemCode.error || !redeemCode.value) {
      handleInputBlur();
      return;
    }
    const voucherCode = redeemCode.value.replace(/\s/g, '');
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      const url = new URL(window.location);
      url.searchParams.set('voucherCode', voucherCode);
      window.history.pushState(null, '', url.toString());
      return svs.components.customer_login.login();
    }
    try {
      let api = 5;
      if (svs.core.detect.feature('ft-its-api-version')) {
        api = 6;
      }
      await svs.core.jupiter.callAsync({
        method: 'GET',
        path: "/voucher/".concat(api, "/getvoucher?voucherId=").concat(voucherCode.toUpperCase())
      });
      window.location.href = "".concat(svs.core.urlMapping.get('ticketGiftHome'), "/").concat(voucherCode, "?manual=true");
    } catch (e) {
      if (e.code === '26 102' || e.code === '26 3') {
        setRedeemCode(_objectSpread(_objectSpread({}, redeemCode), {}, {
          error: redeemCodeError(voucherCode, true)
        }));
      } else {
        svs.tur.apierrors.showErrorMessage({
          response: e.code
        });
      }
    }
  };
  const handleCancel = e => {
    e && e.preventDefault();
    let to = '';
    if (svs.tickets.data.templateConfig.branding === 'triss') {
      to = svs.core.urlMapping.get('trissHome');
    } else {
      to = svs.core.urlMapping.get('skrapspelHome');
    }
    window.location.href = "".concat(window.location.origin, "/").concat(to);
  };
  const formattedVoucherCode = code => code && code.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim();
  const [redeemCode, setRedeemCode] = useState(() => {
    var _svs$utils$paramHandl;
    const voucherParam = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
      key: 'voucherCode'
    })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
    if (voucherParam) {
      svs.utils.paramHandler.remove({
        key: 'voucherCode'
      });
    }
    return {
      value: voucherParam || '',
      error: ''
    };
  });
  const isSkrapspel = branding === 'skrapspel';
  const voucherImg = isSkrapspel ? 'tur-presentpaket.png' : 'triss-presentpaket.png';
  return React.createElement(React.Fragment, null, isSkrapspel && React.createElement(BubbleBackground, null), React.createElement("div", {
    className: "voucher-redeem-container align-center"
  }, React.createElement("div", {
    className: "f-center padding-left-3 padding-right-1 padding-top-2 padding-bottom-1"
  }, React.createElement("img", {
    className: "triss-redeem-img",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets-claim/").concat(voucherImg)
  })), React.createElement("div", {
    className: "voucher-redeem-info"
  }, React.createElement("h1", {
    className: "f-bold padding-left-2 padding-right-2"
  }, "L\xF6s in din presentlott"), React.createElement("div", {
    className: "padding-left-2 padding-right-2"
  }, React.createElement("div", {
    className: "f-bold align-left f-uppercase"
  }, "ange din kod h\xE4r (12 tecken)"), React.createElement(VoucherInput, {
    classes: ['voucher-redeem-input'],
    inputError: redeemCode.error,
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyUp: handleKeyUp,
    value: formattedVoucherCode(redeemCode.value)
  })), React.createElement("div", {
    className: "voucher-redeem-help-container padding-left-2 padding-right-2 padding-bottom-2"
  }, React.createElement(Icon, {
    className: "padding-1",
    icon: "help-2"
  }), React.createElement("div", {
    className: "voucher-redeem-help-text"
  }, "Oinl\xF6sta lotter du f\xE5tt via SMS eller e-post l\xF6ser du in enklast via l\xE4nken i ditt SMS eller e-post.")))), React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text: 'Fortsätt',
      onClick: handleRedeem
    }, {
      secondary: true,
      text: 'Avbryt',
      onClick: handleCancel
    }],
    texts: [{
      content: 'Behöver du hjälp?',
      classes: 'f-bold'
    }, {
      content: 'Kontakta kundservice. Öppet alla dagar'
    }, {
      content: '08-22. Telefon 0770 - 11 11 11.'
    }]
  }));
};
ReactDOM.render( React.createElement(VoucherRedeem, null), document.getElementById('reactContainer'));

 })(window);